import React, { useState } from "react";
import "../all css/heroaboutussection.css";
import { BsInfoCircle } from "react-icons/bs";
import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";
import UserInfo from "./aboutus dialogbox/UserInfo";

export default function LeaderPart(props) {
  const [toggleModal, setToggleModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  function handleInfo(e) {
    console.log(e);
    setUserInfo(e);
    setToggleModal(true);
  } 

  return (
    <div className="each_leader_container" key={Math.random()}>
      <div className="leader_img_container wow bounceInLeft"  data-wow-duration={props.duration}
        data-wow-delay={props.delay}>
        <img
          src={props.leaderImg}
          alt="leader_img"
          className="leader_img_self"
        /> 
      </div>
      <button
        className="leader_name_subname_container wow bounceInRight"
        data-wow-duration={props.duration}
        data-wow-delay={props.delay}
        onClick={() => handleInfo(props)}
      >
        <button className="button_info_self">
          <BsInfoCircle />
        </button>
        <p className="leader_name_text">{props.leaderName}</p>
        <p className="leader_sub_name_text">{props.leaderSubname}</p>
      </button>
      <CustDialogBox
        dialogHeaderName=""
        open={toggleModal}
        onClose={() => {
          setToggleModal(false);
        }}
      >
        <UserInfo userDetails={userInfo} />
      </CustDialogBox>
    </div>
  );
}
